import React from 'react'
import {Button} from 'usg-lib'
import {restUrls} from '../../../../utils/constants'

const GoogleSignInButton = () => {
  const handleClick = () => {
    window.location.href = restUrls.googleOidcLoginUrl;
  }

  return (
    <Button variant="primary" onClick={handleClick}>
      Sign in with Google
    </Button>
  )
}

export default GoogleSignInButton
